import React from 'react';
import docDesignerHOC from '../docDesigner';

function SalesOrders() {
	return <div className="doc-designer">SalesOrders Design</div>;
}

const designerHOC = docDesignerHOC(SalesOrders);

export default designerHOC;
